import * as React from 'react';
import MomentUtils from '@date-io/moment';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { Icon } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker as MuiKeyboardDatePicker,
  KeyboardTimePicker as MuiKeyboardTimePicker,
  KeyboardTimePickerProps,
  KeyboardDatePickerProps,
} from '@material-ui/pickers';
import styled from 'styled-components';

const theme = createTheme({
  palette: {
    primary: blue,
  },
  typography: {
    htmlFontSize: 10,
  },
});

export const DatePicker = (props: KeyboardDatePickerProps) => (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <StyledDatePicker
          className="mui-picker"
          keyboardIcon={<Icon className="fa fa-calendar-o" />}
          {...props}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );

export const TimePicker = (props: KeyboardTimePickerProps) => (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <StyledTimePicker
          className="mui-picker"
          keyboardIcon={<Icon className="fa fa-clock-o" />}
          {...props}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );

const StyledTimePicker = styled(MuiKeyboardTimePicker)`
  input {
    font-size: 14px;
    line-height: 20px;
    padding: 7px 12px;
    height: 20px;
    width: 100%;
  }
  .MuiIcon-root {
    font-size: 1.6rem;
  }
  .MuiTypography-body1 {
    font-size: 1.4rem;
  }
  .MuiSvgIcon-root {
    font-size: 2rem;
  }
  p.MuiFormHelperText-root {
    font-size: 1rem;
    max-width: 20rem;
  }
`;
const StyledDatePicker = styled(MuiKeyboardDatePicker)`
  input {
    font-size: 14px;
    line-height: 20px;
    padding: 7px 12px;
    height: 20px;
    width: 100%;
  }
  .MuiIcon-root {
    font-size: 1.6rem;
  }
  .MuiTypography-body1 {
    font-size: 1.4rem;
  }
  .MuiSvgIcon-root {
    font-size: 2rem;
  }
  p.MuiFormHelperText-root {
    font-size: 1rem;
    max-width: 20rem;
  }
`;
